export const cellStyleKeys = [ "bgColor", "color", "strokeColor", "borderColor", "linkColor" ];
//# sourceMappingURL=style.js.map
